<template>
  <RightDrawer :moreInfo="false">
    <h-loading v-if="isHausefulUserLoading" />

    <div v-else>
      <v-row>
        <v-col cols="9" class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('hausefulUsers.label.name') }}
          </h6>
          <p class="body-2">
            {{ hausefulUser.name }}
          </p>
        </v-col>
      </v-row>

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.type') }}
      </h6>
      <p class="body-2">
        {{ $t(`roles.${hausefulUser.user_type}`) }}
      </p>

      <v-row>
        <v-col cols="3" class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('hausefulUsers.label.isUserTester') }}
          </h6>
          <p class="body-2">
            {{ isUserTester }}
          </p>
        </v-col>
        <v-col class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('hausefulUsers.label.document') }}
          </h6>
          <p class="body-2">
            {{ formatDocument(hausefulUser.cpf) }}
          </p>
        </v-col>
        <v-col class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('hausefulUsers.label.rg') }}
          </h6>
          <p class="body-2">
            {{ documentRg }}
          </p>
        </v-col>
      </v-row>

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.email') }}
      </h6>
      <p class="body-2" v-html="formatMailto(hausefulUser.username)" />

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.phone') }}
      </h6>
      <p class="body-2" v-html="formatWhatsApp(hausefulUser.phone)" />

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.birthDate') }}
      </h6>
      <p class="body-2" v-html="formatDate(hausefulUser.birth_date)" />

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.city') }}
      </h6>
      <p class="body-2">
        {{ formatCityState(hausefulUser) }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{  $t('hausefulUsers.label.services') }}
      </h6>
      <p v-if="services">
        <span
          v-for="service in services"
          :key="service"
          class="d-block body-2 mb-1"
        >
          {{ formatService(service) }}
        </span>
      </p>
      <p v-else class="body-2"> --- </p>
    </div>
  </RightDrawer>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDocument } from '@/util/document'
import { mailto, whatsApp, catalogDateWithoutTime } from  '@/util/catalog'

import RightDrawer from '@/components/app/RightDrawer'

export default {
  name: 'HausefulUsersSummary',

  components: {
    RightDrawer,
  },

  computed: {
    ...mapGetters(['hausefulUser', 'isHausefulUserLoading']),

    isUserTester() {
      return this.hausefulUser.is_tester
        ? this.$t('hausefulUsers.label.yes')
        : this.$t('hausefulUsers.label.no')
    },

    documentRg() {
      return this.hausefulUser.rg ? this.hausefulUser.rg : '---'
    },

    services() {
      return this.hausefulUser?.city?.services?.length && this.hausefulUser.city.services
    }
  },

  methods: {
    formatMailto(email) {
      return email ? mailto(email) : '---'
    },

    formatWhatsApp(phone) {
      return phone ? whatsApp(phone) : '---'
    },

    formatDate(date) {
      return date ? catalogDateWithoutTime(date) : '---'
    },

    formatCityState(item) {
      const city = item?.city
      const cityName = city?.name ? city.name : '---'
      const stateName = city?.state?.acronym ? city.state.acronym : '---'
      return `${cityName} / ${stateName}`
    },

    formatService(service) {
      if (!service) return '---'
      return this.$t(`appointment.type.${service}`)
    }
  },

  data() {
    return {
      formatDocument,
    }
  }
}
</script>
